
  import { defineComponent, PropType } from 'vue';
  import { mapGetters } from 'vuex';

  import InputBlock from '@/common/components/redesigned/InputBlock.vue';
  import TreeMultiselect from '@/common/components/redesigned/TreeMultiselect/TreeMultiselect.vue';
  import { MenuModes } from '@/common/components/redesigned/TreeMultiselect/types';
  import { TDictionary } from '@/common/types/dictionary';

  import { FTS_COMMON_GETTERS_NAME } from '@/modules/ved/store/ftsCommon/name';

  export default defineComponent({
    name: 'FTSWeeklyResponsibleOkatoField',
    components: { TreeMultiselect, InputBlock },
    props: {
      modelValue: {
        type: Array as PropType<number[]>,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    computed: {
      ...mapGetters({
        getOkatoTree: FTS_COMMON_GETTERS_NAME.getOkatoTree,
      }),
      menuModes(): typeof MenuModes {
        return MenuModes;
      },
      responsibleOkatoAccessor: {
        get() {
          return this.modelValue;
        },
        set(newValue: number[]) {
          this.$emit('update:modelValue', [...newValue]);
        },
      },
    },
    methods: {
      getProductsWithSignsLabel(item: TDictionary) {
        return `${item.id} ${item.name}`;
      },
    },
  });
